export default __webpack_public_path__ + "static/media/loading.4404d3f7.gif";